import React from "react";

const Setting = () => {
  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <h2 className="text-2xl font-bold">System Setting</h2>
        </div>

        <div className="card">
          <div className="card-header flex items-center justify-between">
            <button
              type="button"
              //   onClick={() => navigate("/drivers")}
              className="btn btn-outline-secondary ml-2"
            >
              {/* <FaChevronLeft className="mr-1" /> Back */}
            </button>
          </div>

          <div className="card-body ">
            {/* Row 1 */}
            <div className="d-flex align-items-center mb-4">
              <label
                htmlFor="companyName"
                className="mb-0 me-2"
                style={{ width: "15%" }} // ✅ fixed label width
              >
                Company Name
              </label>
              <input
                id="companyName"
                name="companyName"
                type="text"
                value={"Binberu Ride Sharing System"}
                className="form-control"
                placeholder="Enter company name"
                style={{ width: "50%" }} // ✅ fixed input width
              />
            </div>

            {/* Row 2 */}
            <div className="d-flex align-items-center mb-4">
              <label
                htmlFor="ownerName"
                className="mb-0 me-2"
                style={{ width: "15%" }} // ✅ same label width
              >
                Icon
              </label>
              <input
                id="ownerName"
                name="ownerName"
                type="text"
                className="form-control"
                placeholder="Enter owner name"
                style={{ width: "50%" }} // ✅ same input width
              />
            </div>

            {/* Row 3 */}
            <div className="d-flex align-items-center mb-4">
              <label
                htmlFor="ownerName"
                className="mb-0 me-2"
                style={{ width: "15%" }} // ✅ same label width
              >
                CopyRight Content
              </label>
              <input
                id="ownerName"
                name="ownerName"
                type="text"
                value={"Under the Licence of HG"}
                className="form-control"
                placeholder="Enter owner name"
                style={{ width: "50%" }} // ✅ same input width
              />
            </div>

            {/* Row 4 */}
            <div className="d-flex align-items-center mb-4">
              <label
                htmlFor="ownerName"
                className="mb-0 me-2"
                style={{ width: "15%" }} // ✅ same label width
              >
                Playstore Link
              </label>
              <input
                id="ownerName"
                name="ownerName"
                type="text"
                value={"https://playstore.com"}
                className="form-control"
                placeholder="Enter owner name"
                style={{ width: "50%" }} // ✅ same input width
              />
            </div>

            {/* Row 5 */}
            <div className="d-flex align-items-center mb-4">
              <label
                htmlFor="ownerName"
                className="mb-0 me-2"
                style={{ width: "15%" }} // ✅ same label width
              >
                Appstore Link
              </label>
              <input
                id="ownerName"
                name="ownerName"
                type="text"
                value={"https://appstore.com"}
                className="form-control"
                placeholder="Enter owner name"
                style={{ width: "50%" }} // ✅ same input width
              />
            </div>

            {/* Row 6 */}
            <div className="d-flex align-items-center mb-4">
              <label
                htmlFor="ownerName"
                className="mb-0 me-2"
                style={{ width: "15%" }} // ✅ same label width
              >
                Driver Accept timeout (sec)
              </label>
              <input
                id="ownerName"
                name="ownerName"
                type="text"
                value={"60"}
                className="form-control"
                placeholder="60"
                style={{ width: "50%" }} // ✅ same input width
              />
            </div>

            {/* Row 7 */}
            <div className="d-flex align-items-center mb-4">
              <label
                htmlFor="ownerName"
                className="mb-0 me-2"
                style={{ width: "15%" }} // ✅ same label width
              >
                Driver Search Radius (in KM)
              </label>
              <input
                id="ownerName"
                name="ownerName"
                type="text"
                value={"2"}
                className="form-control"
                placeholder="2"
                style={{ width: "50%" }} // ✅ same input width
              />
            </div>

            {/* Row 8 */}
            <div className="d-flex align-items-center mb-4">
              <label
                htmlFor="ownerName"
                className="mb-0 me-2"
                style={{ width: "15%" }} // ✅ same label width
              >
                Tax (in %)
              </label>
              <input
                id="ownerName"
                name="ownerName"
                type="text"
                value={"15"}
                className="form-control"
                placeholder="Add Tax"
                style={{ width: "50%" }} // ✅ same input width
              />
            </div>

            <div className="d-flex align-items-center mb-4">
              <label
                htmlFor="ownerName"
                className="mb-0 me-2"
                style={{ width: "15%" }} // ✅ same label width
              >
                Document Path
              </label>
              <input
                id="ownerName"
                name="ownerName"
                type="text"
                value={"F://Document/Path"}
                className="form-control"
                placeholder="Add Tax"
                style={{ width: "50%" }} // ✅ same input width
              />
            </div>

            {/* Row 9 */}
            <div className="d-flex align-items-center mb-4">
              <label
                htmlFor="ownerName"
                className="mb-0 me-2"
                style={{ width: "15%" }} // ✅ same label width
              >
                Contact Email
              </label>
              <input
                id="ownerName"
                name="ownerName"
                type="text"
                value={"binberu@gmail.com"}
                className="form-control"
                placeholder="Add contact Email"
                style={{ width: "50%" }} // ✅ same input width
              />
            </div>

            {/* Row 7 */}
            <div className="d-flex align-items-center mb-4">
              <label
                htmlFor="ownerName"
                className="mb-0 me-2"
                style={{ width: "15%" }} // ✅ same label width
              >
                Google Map Key
              </label>
              <input
                id="ownerName"
                name="ownerName"
                type="text"
                value={"2zaSyAbJIqSfbwgfz4NfYdcGQN"}
                className="form-control"
                placeholder="2zaSyAbJIqSfbwgfz4NfYdcGQN"
                style={{ width: "50%" }} // ✅ same input width
              />
            </div>
          </div>

          <div className="card-footer d-flex">
            <button type="submit" className="btn btn-primary me-2">
              Update Site Info
            </button>
            <button type="reset" className="btn btn-secondary ml-4">
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Setting;
